import { jsx } from 'react/jsx-runtime';
import { useGitRepository } from './hooks.esm.js';
import { ADDON_ISSUE_REPO_TYPES_SUPPORTED } from './constants.esm.js';
import { ReportIssueAddonContent } from './ReportIssueContent.esm.js';

const ReportIssueAddon = ({
  debounceTime = 500,
  templateBuilder
}) => {
  const repository = useGitRepository();
  if (!repository || !ADDON_ISSUE_REPO_TYPES_SUPPORTED.includes(repository.type)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    ReportIssueAddonContent,
    {
      debounceTime,
      templateBuilder,
      repository
    }
  );
};

export { ReportIssueAddon };
//# sourceMappingURL=ReportIssue.esm.js.map
